import { ApiResponse } from '@nohara-dxdev/oidc-core';

import { api } from '@/lib/api-client';

interface PresignResponse {
  key: string;
  uploadUrl: string;
}

export async function uploadAttachment(
  orgId: string,
  projectId: string,
  sessionId: string,
  file: File,
): Promise<string> {
  // Step 1: Get presigned PUT URL from API
  const { data } = await api.post<unknown, ApiResponse<PresignResponse>>(
    `/orgs/${orgId}/projects/${projectId}/ai-agent/sessions/${sessionId}/attachments`,
    { filename: file.name, contentType: file.type, size: file.size },
  );
  // Step 2: PUT file directly to S3
  let response: Response;
  try {
    response = await fetch(data.uploadUrl, {
      method: 'PUT',
      body: file,
      headers: { 'Content-Type': file.type },
    });
  } catch (error) {
    throw new Error(
      `Failed to upload attachment to S3: ${error instanceof Error ? error.message : String(error)}`,
    );
  }
  if (!response.ok) {
    throw new Error(`Failed to upload attachment to S3: ${response.status} ${response.statusText}`);
  }
  return data.key; // S3 key for POST /messages
}
